import useTakerMarketsGroups from '@/enterprise/data/useTakerMarketsGroups';
import { OfferModalWithContext } from '@/enterprise/features/offerModal/OfferModalContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import PreferredMarketingContent from '../../preferred/PreferredMarketingContent';
import MarketTable from './MarketTable';

const PreferredRateMarketTableComponent = () => {
  const {
    PREFERRED: { takerMarkets },
  } = useTakerMarketsGroups();

  // if Preferred Market tab is selected and there are no taker markets, show the preferred marketing information modal
  if (takerMarkets.length === 0) {
    return <PreferredMarketingContent />;
  }

  return (
    <OfferModalWithContext>
      <MarketTable takerMarkets={takerMarkets} />
    </OfferModalWithContext>
  );
};

const PreferredRateMarketTable = () => {
  return (
    <QueryBoundaries>
      <PreferredRateMarketTableComponent />
    </QueryBoundaries>
  );
};

export default PreferredRateMarketTable;
